module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Não foi possível ativar sua conta","subtitle":"Você pode tentar de novo em alguns meses."},"en-US":{"title":"We could not activate your account","subtitle":"You can try again in a few months."}}')
  delete Component.options._Ctor
}
